<template>
  <div class="mb-4 p-3">
    <div class="row align-items-center">
      <div class="col-4 m-0">
        <div class="avatar-upload">
          <div class="avatar-edit">
            <input
              id="imageUpdateUpload"
              type='file'
              accept=".png, .jpg, .jpeg"
              @change="onChangeLogo"
            />
            <label for="imageUpdateUpload"><i class="uil uil-pen"></i>  </label>
          </div>
          <div class="avatar-preview" style="height:auto; width:auto; aspect-ratio: 1 / 1;">
            <img
              alt
              ref="imageEditPreview"
              class="avatar-lg rounded-lg "
              style="object-fit: cover;"
            />
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-lg-12">
        <TextField 
          :placeholder="$t('brand.form.name.placeholder')"
          :label="$t('brand.form.name.label')"
          v-model="model.name"
        />
        <textarea
          class="form-control" 
          name="remarks"
          :placeholder="$t('brand.form.remarks.placeholder')"
          rows="5"
          v-model="model.remarks"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import FormMixins from '@mixins/form'

export default {
  mixins: [ FormMixins ],
  components: {
    TextField
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      model: {}  
    }
  },
  computed: {
    brandID () {
      let parameters = this.parameters || {}
      return parameters.brandID
    },
    submitted () {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.brandID

      return this.$store.dispatch('brand/find', param)
      .then(result => {
        if (result && result.data) {
          this.model = result.data
          if(result.data.logo)
          this.$refs.imageEditPreview.src = result.data.logo
          else
          this.$refs.imageEditPreview.src = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png';
        }
      })
    },
    onChangeLogo(e) {
      let file = e.target.files[0]
      this.model.file = file
      this.$refs.imageEditPreview.src = URL.createObjectURL(file)
    }
  },
  watch: {
    brandID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {

    if (this.brandID) {
      this.fetchData()
    }
  }
}
</script>

<style lang="scss">
  .image_background {
    background: rgb(207, 207, 207);
  }
</style>